import $ from 'jquery'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'

/**
 * Disables a checkbox and displays a message when clicking on the checkbox
 * which describes why the checkbox was disabled
 *
 * @param {Element|jQuery} containerEl the parent element which contains the tooltip
 * @param {String} content the tooltip's content
 * @param {Object} tooltipOptions any additional options to pass to the tooltip
 */
function disableCheckbox(containerEl, content, tooltipOptions) {
	containerEl = $(containerEl)
	containerEl.find('input').prop('disabled', true)
	let svgEl = containerEl.find('svg')

	let tooltipOpts = _.extend({}, {
		content,
		attachTo: svgEl,
		arrow: 'left', // Put arrow on left side of tooltip to prevent shift #51399
	}, tooltipOptions)

	let tooltip
	containerEl.on('click.disableCheckbox', () => {
		tooltip = new Tooltip(tooltipOpts).render()
	})

	return tooltip
}

function unDisableCheckbox(containerEl) {
	containerEl = $(containerEl)
	containerEl.find('input').prop('disabled', false)
	containerEl.off('click.disableCheckbox')
}

export { disableCheckbox }
export { unDisableCheckbox }
